<template>
  <product-loading v-if="loading" />
  <v-container v-else-if="product" class="pt-10">
    <v-row>
      <v-col
        md="8"
        xl="6"
        cols="12"
        class="offset-xl-1 pa-6"
      >
        <div class="d-flex flex-column-reverse flex-md-row">
          <div class="d-flex d-md-block justify-center mr-md-3">
            <v-card
              v-for="(image, index) in product.images"
              class="d-inline-block d-md-block mb-md-3 ma-1 ma-md-0 overflow-hidden"
              flat
              rounded
              link
              @click="selectedImage = image"
              :key="index"
            >
              <v-img :src="image.src" height="48" maxWidth="48" />
            </v-card>
          </div>
          <div class="mb-1 min-w-0 mx-md-auto">
            <div v-if="!selectedImage" class="grey lighten-2" style="width: 100%">
              <v-icon
                class="d-flex"
                color="grey lighten-1"
                size="150"
                style="height: 300px"
              >mdi-image-outline</v-icon>
            </div>
            <v-img
              v-else-if="$vuetify.breakpoint.mobile"
              :src="selectedImage.src"
              height="300"
              width="100%"
              contain
            />
            <image-magnifier
              v-else
              :src="selectedImage.src"
              :zoomSrc="selectedImage.src"
              zoomClass="v-sheet theme--light elevation-4 rounded"
              zoomWidth="372"
              zoomHeight="603"
              maskHeight="183.73"
            />
          </div>
        </div>
      </v-col>
      <v-col
        md="4"
        xl="3"
        cols="12"
        style="min-height: 430px;"
        class="pa-6"
      >
        <div>
          <h1 class="text-h5 text-lg-h4 mb-1">{{ product.title }}</h1>
        </div>

        <product-selection v-if="product.variants.length > 1" v-model="selectedVariant" :product="product">
          <div v-if="displayMenu" class="pb-4 pt-4">
            <label class="font-weight-bold">You will get:</label>
            <v-list dense>
              <v-list-item class="pb-0 pt-0">
                <v-list-item-content class="pb-0 pt-0 text-subtitle">Breakfasts:</v-list-item-content>
                <v-list-item-content class="pb-0 pt-0 align-end text-right">
                  <label class="text-right">{{ breakfast }}</label>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="pb-0 pt-0">
                <v-list-item-content class="pb-0 pt-0 text-subtitle">Entrées:</v-list-item-content>
                <v-list-item-content class="pb-0 pt-0 align-end text-right">
                  <label class="text-right">{{ entrees }}</label>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <v-list-item class="pb-0 pt-0">
                <v-list-item-content class="pb-0 pt-0 text-subtitle">Total Meals:</v-list-item-content>
                <v-list-item-content class="pb-0 pt-0 align-end">
                  <label class="text-right">{{ breakfast + entrees }}</label>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </product-selection>

        <the-price v-else-if="selectedVariant" :price="selectedVariant.price" class="justify-end" />

        <span v-show="selectedVariant && !selectedVariant.available" class="subtitle red--text">Out of Stock</span>
        <v-btn
          large
          :disabled="!selectedVariant || !selectedVariant.available"
          color="success"
          class="mt-3"
          block
          @click="addToCart"
        >
          <v-icon>mdi-cart-plus</v-icon>
          <span class="flex-grow-1">Add to Cart</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mx-auto">
        <v-card class="pa-6">
          <div v-if="product.description" v-dompurify-html="product.descriptionHtml" class="py-2 body-1 font-weight-medium"></div>
          <div v-else class="font-italic">No description.</div>
        </v-card>

        <menu-items v-if="displayMenu" :productHandle="product.handle" />
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-alert type="error">Can not find product.</v-alert>
  </v-container>
</template>
<script>
import MenuItems from './Menu/MenuItems.vue';
import ProductLoading from './utilities/productLoading.vue';
import ProductSelection from './utilities/productSelection.vue';
import ThePrice from './utilities/thePrice.vue';
export default {
  name: 'ProductDetails',
  components: { ProductSelection, ThePrice, MenuItems, ProductLoading },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data: function () {
    return {
      product: null,
      selectedImage: null,
      selectedVariant: null,
      loading: false,
      menu: [],
      menuType: ''
    };
  },
  methods: {
    addToCart: function () {
      const lineItemsToAdd = [
        {
          variantId: this.selectedVariant.id,
          quantity: 1
        }
      ];
      this.$store.dispatch('cart/addItem', lineItemsToAdd);
    }
  },
  computed: {
    displayMenu: function () {
      return this.product?.productType === 'Meal Kit' || this.product?.productType === 'Chef Curated Meal Plan';
    },
    breakfast: function () {
      if (this.displayMenu && this.selectedVariant?.selectedOptions[1]) {
        return this.selectedVariant?.selectedOptions[1].value * 1;
      }
      return 0;
    },
    entrees: function () {
      if (this.displayMenu && this.selectedVariant?.selectedOptions[1]) {
        return this.selectedVariant?.selectedOptions[1].value * 2;
      }
      return 0;
    }
  },
  created: function () {
    this.loading = true;
    this.$shopify.product.fetch(this.id).then((product) => {
      this.product = product;
      this.selectedImage = product.images[0];
      this.selectedVariant = product.variants[0];
      this.loading = false;
    });
  }
};
</script>
